import React, { useContext, useState } from "react";

import { Button } from "../../Button";

import GeneralPageContext from "../../../templates/GeneralPageContext";

import t from "../../../lib/translate";
import { generateClassString as gcs } from "../../../lib/helper/generateClassString";

import * as styles from "./user.module.less";

function UserNav({ className }) {
    const [show] = useState(false);
    const {
        stdPages: { pageCustomerCenter }
    } = useContext(GeneralPageContext);

    if (!pageCustomerCenter) return null;

    return (
        <div
            className={gcs(
                styles.buttonWrapper,
                [show, styles.activeMenu],
                className
            )}
        >
            <Button
                type="secondary"
                renderAs="link"
                to={pageCustomerCenter}
                icon="user"
                aria-label={t`navigation.iconNavigation.login`}
            >
                <span>{t("navigation.iconNavigation.login")}</span>
            </Button>
        </div>
    );
}

export { UserNav };
